import { render, staticRenderFns } from "./tongueTriangleL.vue?vue&type=template&id=575afd03&"
import script from "./tongueTriangleL.vue?vue&type=script&lang=js&"
export * from "./tongueTriangleL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports